import React, { FC, useState } from 'react'
import { cn } from 'shared/utils'

import { REGEXP } from 'shared/consts/regExp'
import { StoryArticleEmbededProps } from './StoryArticleEmbeded.props'

import './StoryArticleEmbeded.scss'

const StoryArticleEmbeded: FC<StoryArticleEmbededProps> = ({
  data: { thumbnail_url, thumbnail_width, provider_url, author_name, provider_name, title },
  onOpen
}) => {
  const [loaded, setLoaded] = useState(false)

  return (
    <div className="embeded-preview" onClick={onOpen}>
      <div className="embeded-preview__thumbnail">
        {loaded ? (
          <i className="fas fa-play embeded-preview__thumbnail_icon" />
        ) : (
          <div className="embeded-preview__thumbnail_icon icon-wrapper">
            <i className="fab fa-tiktok" />
          </div>
        )}
        <img
          src={thumbnail_url}
          width={thumbnail_width}
          alt={title}
          onLoad={() => setLoaded(true)}
          className={cn('embeded-preview__thumbnail_img', { hidden: !loaded })}
        />
      </div>
      <div className="embeded-preview__info">
        <div className="embeded-preview__info__icon icon-wrapper">
          <i className="fab fa-tiktok" />
        </div>
        <p className="embeded-preview__provider">{provider_url?.replace(REGEXP.HTTPS_URL, '')}</p>
        <p className="embeded-preview__author">
          {author_name} <b>on {provider_name}</b>
        </p>
        <h5 className="embeded-preview__title">{title}</h5>
      </div>
      <div className="embeded-preview-hover" />
    </div>
  )
}

export default StoryArticleEmbeded
